/**
 * Alert Engine - Phase 15 (Backend-connected)
 *
 * Delegates evaluation to /api/alerts/evaluate backend endpoint.
 */
import { evaluateAlerts } from './alertStore';

export async function evaluateAlertsForScope(scope = {}) {
  try {
    const result = await evaluateAlerts();
    return {
      triggered: result.alerts || [],
      suppressed: [],
      updated: [],
      autoResolved: [],
      evaluatedAt: result.evaluated_at,
      rulesChecked: result.rules_checked,
      newAlertsCreated: result.new_alerts_created,
    };
  } catch (err) {
    console.error('[AlertEngine] Evaluation failed:', err.message);
    return { triggered: [], suppressed: [], updated: [], autoResolved: [] };
  }
}

export async function runEvaluationCycle() {
  return evaluateAlertsForScope({});
}

export default {
  evaluateAlertsForScope,
  runEvaluationCycle,
};
